import i18n from "@/i18n"
import { RouteRecordRaw } from "vue-router"

const { t } = i18n.global

export const atividadesRota = (): RouteRecordRaw[] => [
  {
    path: "/atividades",
    name: "Atividades",
    meta: {
      titulo: t("tituloDaRotaDeAtividades"),
      regras: ["auth", "cancelador"],
      modulo: "AtividadesRealizadas",
      operador: "e",
      permissoes: [],
    },
    component: () =>
      import(
        /* webpackChunkName: "Atividades" */
        "@/paginas/Atividades/CalendarioDeAtividades/CalendarioDeAtividades.vue"
      ),
  },
  {
    path: "/tipos-atividade",
    name: "TipoDeAtividades",
    meta: {
      titulo: t("tituloDaRotaDeTiposDeAtividade"),
      regras: ["auth", "cancelador"],
      modulo: "TiposDeAtividade",
      operador: "ou",
      permissoes: ["visualizar", "listar", "editar", "deletar", "criar"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Atividades" */
        "@/paginas/Atividades/TipoDeAtividades/TipoDeAtividades.vue"
      ),
  },
  {
    path: "/criar-tipo-de-atividade",
    name: "NovoTipoDeAtividade",
    meta: {
      titulo: t("tituloDaRotaDeCriarTipoDeAtividade"),
      regras: ["auth", "cancelador"],
      modulo: "TiposDeAtividade",
      operador: "ou",
      permissoes: ["criar"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Criar Tipo De Atividade" */
        "@/paginas/Atividades/NovoTipoAtividade/NovoTipoAtividade.vue"
      ),
    children: [
      {
        path: "",
        name: "AdicionarAtributoTipoAtividade",
        meta: {
          regras: ["auth", "cancelador"],
          modulo: "TiposDeAtividade",
          operador: "ou",
          permissoes: ["criar"],
        },
        component: () =>
          import(
            /* webpackChunkName: "AdicionarAtributo" */
            "@/components/Atributos/OAdicionarAtributo/OAdicionarAtributo.vue"
          ),
      },
      {
        path: "criar-atributos",
        name: "CriarAtributosTipoAtividade",
        meta: {
          titulo: t("tituloDaRotaDeCriarAtributos"),
          regras: ["auth", "cancelador"],
          modulo: "TiposDeAtividade",
          operador: "ou",
          permissoes: ["criar"],
        },
        component: () =>
          import(
            /* webpackChunkName: "CriarAtributos" */
            "@/components/Atributos/OCriarAtributo/OCriarAtributo.vue"
          ),
      },
    ],
  },
  {
    path: "/criar-tipo-de-atividade/:idTipoDeAtividade",
    name: "EditarTipoDeAtividade",
    props: true,
    meta: {
      titulo: t("tituloDaRotaDeEditarTipoDeAtividade"),
      regras: ["auth", "cancelador"],
      modulo: "TiposDeAtividade",
      operador: "ou",
      permissoes: ["editar"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Criar Tipo De Atividade" */
        "@/paginas/Atividades/NovoTipoAtividade/NovoTipoAtividade.vue"
      ),
    children: [
      {
        path: "",
        name: "AdicionarAtributoEditarTipoAtividade",
        meta: {
          regras: ["auth", "cancelador"],
          modulo: "TiposDeAtividade",
          operador: "ou",
          permissoes: ["editar"],
        },
        component: () =>
          import(
            /* webpackChunkName: "AdicionarAtributo" */
            "@/components/Atributos/OAdicionarAtributo/OAdicionarAtributo.vue"
          ),
      },
      {
        path: "criar-atributos",
        name: "CriarAtributosEditarTipoAtividade",
        meta: {
          titulo: t("tituloDaRotaDeCriarAtributos"),
          regras: ["auth", "cancelador"],
          modulo: "TiposDeAtividade",
          operador: "ou",
          permissoes: ["editar"],
        },
        component: () =>
          import(
            /* webpackChunkName: "CriarAtributos" */
            "@/components/Atributos/OCriarAtributo/OCriarAtributo.vue"
          ),
      },
    ],
  },
  {
    path: "/gestao-travamentos",
    name: "GestaoTravamentos",
    meta: {
      titulo: t("tituloDaRotaDeGestaoDeTravamentos"),
      regras: ["auth", "cancelador"],
      modulo: "Travamento",
      operador: "ou",
      permissoes: ["visualizar"],
    },
    component: () => import(
      /* webpackChunkName: "GestaoTravamento" */
      "@/paginas/Atividades/GestaoTravamento/GestaoTravamento.vue"
    ),
  }
]
